import React, { useMemo } from "react"
import styled from "styled-components"
import clsx from "clsx"
import BodyText from "./Typography/BodyText"

const CharacterCountContainer = styled.div`
  color: ${(props) => props.theme.palette.primary_one};

  &.limit-exceeded {
    color: ${(props) => props.theme.palette.error};
  }
`

interface CharacterCountProps {
  currentLength: number
  maxLength: number
  disabledCharacter?: boolean
}

const CharacterCount: React.FC<CharacterCountProps> = (props: CharacterCountProps) => {
  const { currentLength, maxLength, disabledCharacter } = props

  const isLimitExceeded = useMemo(() => currentLength > maxLength, [currentLength, maxLength])

  return (
    <CharacterCountContainer className={clsx({ "limit-exceeded": isLimitExceeded })}>
      <BodyText size="small" color={disabledCharacter ? "disabled" : "primary-dark"}>
        {currentLength}/{maxLength}
      </BodyText>
    </CharacterCountContainer>
  )
}

export default CharacterCount
